/* eslint-disable */
import { useContext, useEffect } from 'react'
import Cookies from 'js-cookie'
import { Outlet, useNavigate } from 'react-router-dom'
import { AuthContext, redirectToLogin } from '../Auth'
import { ChooseOrgAndAppProvider } from './ChooseOrgAndAppProvider'

export default function PrivateRoute() {
  const { auth, setAuth } = useContext(AuthContext)
  const navigate = useNavigate()
  useEffect(() => {
    const token = Cookies.get('auth_token') || ''
    if (!token) {
      redirectToLogin()
      return
    }
    setAuth(true)
  }, [setAuth])

  if (!auth) {
    return <h1>Loading...</h1>
  }
  return (
    <ChooseOrgAndAppProvider>
      <Outlet />
    </ChooseOrgAndAppProvider>
  )
}
